import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";

export const useHeaderDesktopContent = () => {
  const { isFaireDirectActiveInLoggedOut } = useFaireDirectBrand();
  const { showNavHeader: showMarketNavHeader } = useMarketStore([
    "showNavHeader",
  ]);

  const isMarketLinkVisible = showMarketNavHeader;

  return {
    isFaireDirectActiveInLoggedOut,
    isMarketLinkVisible,
  };
};
